import React, { useState, useEffect } from 'react'
import { Row } from 'scripts/styled-components'
import apiFetch from '@wordpress/api-fetch'
import { Wrapper, InnerWrapp, Index, Footer } from './custom.styled'
import { Splide, SplideSlide } from '@splidejs/react-splide'
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll'
import { AnimationOnScroll } from 'react-animation-on-scroll'
import Customer from './customer'
import Plus from './plus.svg'

const CustomersLogo = data => {
  const [customers, setCustomers] = useState([])
  const [isShowMore, setIsShowMore] = useState(false)

  useEffect(() => {
    if (data.display_teasers === 'all') {
      apiFetch({
        path: '/wp/v2/customer?per_page=99&_embed',
      }).then(response => setCustomers(response))
    } else if (data.display_teasers === 'category') {
      apiFetch({
        path: `/wp/v2/customer?customer_category=${data.category}&per_page=99&_embed`,
      }).then(response => setCustomers(response))
    } else if (data.display_teasers === 'manually') {
      if (data.customers) {
        let customerIds = String(data.customers)
        apiFetch({
          path: '/wp/v2/customer?_embed=&include=' + customerIds,
        }).then(response => setCustomers(response))
      }
    }
  }, [data.display_teasers, data.category, data.customers])

  const Customers = () => {
    return (
      <>
        {customers.length > 0 &&
          customers.map((item, key) => (
            <>
              {data.isSlider ? (
                <SplideSlide>
                  <Customer customer={item} isSlider={data.isSlider} />
                </SplideSlide>
              ) : (
                <Customer
                  customer={item}
                  isSlider={data.isSlider}
                  grid={data.grid}
                  hidden={data.showMore && key >= data.grid && !isShowMore}
                />
              )}
            </>
          ))}
      </>
    )
  }

  const splide_options = {
    type: 'loop',
    autoWidth: true,
    pagination: false,
    arrows: false,
    perPage: 6,
    breakpoints: {
      1024: {
        perPage: 3,
      },
      500: {
        perPage: 2,
      },
    },
  }

  return (
    <Wrapper>
      {data.index && (
        <AnimationOnScroll
          animateIn="animate__fadeInDown"
          initiallyVisible={data.isEditor}
        >
          <Index>{data.index}</Index>
        </AnimationOnScroll>
      )}
      <InnerWrapp>
        {data.isSlider ? (
          <Splide options={splide_options} extensions={{ AutoScroll }}>
            <Customers />
          </Splide>
        ) : (
          <>
            <Row
              mobileDirection={'wrap'}
              direction={'wrap'}
              gap={'20px'}
              rowGap={'70px'}
            >
              <Customers />
            </Row>
          </>
        )}
      </InnerWrapp>
      {data.showMore && !isShowMore && (
        <Footer>
          <button onClick={() => setIsShowMore(true)}>
            Alle anzeigen <img src={Plus} />
          </button>
        </Footer>
      )}
    </Wrapper>
  )
}

export default CustomersLogo
